import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router, Route, Link, hashHistory, browserHistory, IndexRoute, RedirectFunction, IndexRedirect } from "react-router";
import { MasonDotNet } from "MasonDotNet";
import * as $ from "jquery";
import * as Fourier from "Showcase/Fourier";
import { Parametric } from "Showcase/Component/Parametric";
import { Markov } from "Markov/Markov";
import { NumericMatrix } from "UI/Math/Matrix";
import { Nav } from "Nav";
      
require("./global.scss");
// The expose loader puts these modules onto Window, where various libraries are looking for them
require("expose?React!react"); // React dev tools
require("expose?jQuery!jquery"); // To make bootstrap happy
require("expose?Tether!tether"); // bootstrap
require("bootstrap");

$(document).ready(() => {
    // Todo: what's a better way to handle multiple pages in one bundle.
    let root = document.getElementById("root");
    let router = <Router history={browserHistory}>
        <Route path="/main" component={MasonDotNet}/>
        <Route path="/" component={Nav}>
            <IndexRedirect to="/main"/>
            <Route path="/markov/:graphSerialization" component={Markov}/>
            <Route path="/markov" component={Markov}/>
            <Route path="/parametric" component={Parametric}/>
            <Route path="/matrixtest" component={NumericMatrix}/>
        </Route>
    </Router>;

    if (root) {
        ReactDOM.render(router, root);
    }
})



// WEBPACK FOOTER //
// ./src/code/main.tsx